import { Link } from 'react-router-dom';
import { safetyNotices } from '@/mocks/faqs';

export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 bg-foreground-900">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="relative w-full aspect-[4/5] overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20abstract%20composition%20of%20warm%20amber%20glass%20object%20and%20cream%20linen%20texture%20creating%20protective%20shelter%20visual%20metaphor%2C%20gentle%20morning%20backlight%2C%20minimal%20conceptual%20photography%2C%20safety%20and%20trust%20theme%2C%20warm%20neutral%20palette%2C%20no%20text%20no%20logos&width=800&height=1000&seq=v2-safety-shield-img&orientation=portrait"
                alt="Buyer safety and trust visual"
                title="Sugargoo Spreadsheet Safety Guide"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 w-full h-full border border-background-200/20 rounded-lg -z-10"></div>
          </div>

          <div>
            <span className="inline-block px-4 py-1.5 text-xs font-semibold border border-white/20 text-white/80 rounded-full mb-6 whitespace-nowrap">
              Why Trust Us
            </span>
            <h2 className="text-3xl md:text-5xl font-heading italic text-white leading-tight">
              Your Trusted<br />
              Sugargoo<br />
              <span className="text-primary-400">Resource Hub</span>
            </h2>
            <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-md">
              We provide original, research-backed content to help you navigate the world of Sugargoo spreadsheets safely. Every guide is written by experienced community members who understand the platform inside and out.
            </p>

            <div className="mt-6 space-y-3">
              {safetyNotices.map((notice, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/20 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-primary-400 text-xs"></i>
                  </span>
                  <p className="text-sm text-white/65 leading-relaxed">{notice}</p>
                </div>
              ))}
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}